import CalibrationTracker from '@/components/CalibrationTracker/CalibrationTracker';
import ESTip from '@/components/TipsToConsider/ESTip';
import {ES_TIP_TYPES} from '@/consts/experienceScore/esTipTypes';
import useCalibration from '@/hooks/experienceScore/useCalibration';
import {getContent} from '@/services/content/content';
import {formatPlural, interpolate} from '@/services/localization/localizationService';

const CalibrationPopup = () => {
    const {experienceCount, experienceThreshold} = useCalibration();
    const {icon, description, descriptionPluralForms} = getContent().calibrationContent ?? {};
    const experiences = formatPlural(experienceThreshold, descriptionPluralForms);

    return (
        <div className='flex min-h-dvh w-full flex-col justify-center gap-6 bg-secondary p-4 text-primary dark:bg-orion-1 dark:text-romance'>
            <CalibrationTracker count={experienceCount} total={experienceThreshold} />
            <ESTip
                className='w-full'
                type={ES_TIP_TYPES.SUGGEST}
                icon={icon}
                description={description && experiences ? interpolate(description, experiences) : undefined}
            />
        </div>
    );
};

export default CalibrationPopup;
